import { studentConferencesConstants } from "../_constants";

const initialState = {
  students: []
};

export function studentConferences(state = initialState, action) {
  switch (action.type) {
    case studentConferencesConstants.LOAD:
        return {
      ...state,
      students: action.data,
    };
    case studentConferencesConstants.RESET:
        return {
      ...state,
      students: [],
    };
    default:
      return state;
  }
}
